"use strict";

exports.__esModule = true;
exports["default"] = Close;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Close(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.662 17.335l-.001 13.327c0 .74.6 1.337 1.335 1.337.739 0 1.334-.595 1.334-1.337l.001-13.326h13.33a1.335 1.335 0 1 0-.001-2.67l-13.328-.001V1.336A1.329 1.329 0 0 0 15.997.001c-.734 0-1.335.595-1.334 1.334l-.001 13.331-13.327-.002a1.335 1.335 0 0 0 0 2.67l13.327.001z"
  }));
}